/** Static copy for the Payment History tab. */
export const PAYMENT_HISTORY_CONFIG = {
  title: 'Payment History',
  subtitle: 'Batch payments made by this seller and the warranties they funded.',
  exportCsv: 'Export CSV',

  loadingBadge: 'loading',
  paymentSingular: 'payment',
  paymentPlural: 'payments',

  searchPlaceholder: 'Reference # or warranty #',
  statusPlaceholder: 'All statuses',
  dateRangePlaceholder: 'Date range',
  dateRangeStart: 'Start',
  dateRangeEnd: 'End',
  clear: 'Clear',

  columns: {
    date: 'Date',
    reference: 'Reference #',
    method: 'Payment Method',
    warranties: 'Warranties',
    total: 'Total',
    status: 'Status',
  },
} as const;

/** Static copy for the batch payment detail dialog. */
export const PAYMENT_HISTORY_DETAIL_CONFIG = {
  title: 'Batch payment details',
  subtitle: 'The warranties included in this batch payment.',

  date: 'Date',
  referenceNumber: 'Reference number',
  paymentMethod: 'Payment method',
  status: 'Status',
  receipt: 'Receipt',
  downloadPdf: 'Download PDF',

  total: 'Total',
  warrantySingular: 'warranty',
  warrantyPlural: 'warranties',

  loadError: "Something went wrong loading this batch's warranties. Please try again.",
  releasedNote:
    'This batch no longer holds any warranties. Cancelled and expired batches release their warranties back to the unfunded list.',
  done: 'Done',

  columns: {
    warranty: 'Warranty #',
    buyer: 'Buyer',
    coverage: 'Coverage',
    netAmount: 'Net Amount',
  },
} as const;
